import Table from "../../componentsTable/TanStackTable";
import { petitions } from "../../../api/calls";
import { useContext, useEffect, useState, useRef } from "react";
import { toast } from "sonner";
import { DataContext } from "../../../context/DataContext";
import { useForm } from "react-hook-form";
import TableLoad from "../../componentsTools/TableLoad";
import { exportToExcel_v1 } from "../../componentsTools/ExportToExcel";

export default function Conductores() {
  const { session, idEmpresa } = useContext(DataContext);
  const [filtering, setFiltering] = useState("");
  const [estado, setEstado] = useState(false);
  const [conductores, setConductores] = useState([]);
  const [load, setLoad] = useState(true);

  const modalRef = useRef(null);
  const modalRef2 = useRef(null);

  const closeModal = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef.current);
    modalInstance.hide();
  };

  const form1 = useForm({
    defaultValues: {
      nombre: "",
      paterno: "",
      materno: "",
      direccion: "",
      telefono: "",
    },
  });

  const form2 = useForm({
    defaultValues: {
      idConductor: "",
      nombre: "",
      paterno: "",
      materno: "",
      direccion: "",
      telefono: "",
    },
  });

  const columns = [
    {
      header: "Nombre",
      accessorKey: "nombre",
    },
    {
      header: "Apellido Paterno",
      accessorKey: "paterno",
    },
    {
      header: "Apellido Materno",
      accessorKey: "materno",
    },
    {
      header: "Dirección",
      accessorKey: "direccion",
    },
    {
      header: "Telefono",
      accessorKey: "telefono",
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      cell: ({ row }) => (
        <div className="btn-reveal-trigger position-static">
          <button
            className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
            type="button"
            data-bs-toggle="dropdown"
            data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
            data-bs-reference="parent"
          >
            <span className="fas fa-ellipsis-h fs-10"></span>
          </button>
          <div className="dropdown-menu dropdown-menu-end py-2">
            <button
              className="dropdown-item text-info"
              onClick={() => handleUpdate(row.original)}
            >
              Editar
            </button>
            <button
              className="dropdown-item text-danger"
              onClick={() => deleteConductor(row.original)}
            >
              Eliminar
            </button>
          </div>
        </div>
      ),
    },
  ];

  const handleUpdate = (row) => {
    form2.setValue("idConductor", row.idConductor, { shouldValidate: true });
    form2.setValue("nombre", row.nombre, { shouldValidate: true });
    form2.setValue("paterno", row.paterno, { shouldValidate: true });
    form2.setValue("materno", row.materno, { shouldValidate: true });
    form2.setValue("direccion", row.direccion, { shouldValidate: true });
    form2.setValue("telefono", row.telefono, { shouldValidate: true });
    const modal = new window.bootstrap.Modal(modalRef2.current);
    modal.show();
  };

  useEffect(() => {
    const fetchConductores = async () => {
      setLoad(true);
      const obj = session();
      const response = await petitions.getConductor(idEmpresa(), obj.token);
      if (response.status === "success") {
        setConductores(response.data);
        setLoad(false);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchConductores();
  }, [idEmpresa, session, estado]);

  const deleteConductor = async (row) => {
    toast("¿Estas seguro(a) de eliminar este conductor?", {
      action: {
        label: "Confirmar",
        onClick: async () => {
          const response = await petitions.deleteConductor(
            idEmpresa(),
            session().token,
            row
          );
          if (response.status === "success") {
            setEstado(!estado);
            toast.success("Conductor eliminado correctamente"); 
          } else {
            var msg =
              typeof response.code === "string"
                ? response.message
                : response.data;
            toast.error(msg);
          }
        },
      },
    });
  }

  const sendConductor = form1.handleSubmit(async (data) => {
    const response = await petitions.insertConductor(
      idEmpresa(),
      session().token,
      data
    );
    if (response.status === "success") {
      if (response.data) {
        closeModal();
        setEstado(!estado);
        toast.success("Conductor registrado");
        form1.reset();
      } else {
        toast.warning("Ocurrió un problema, inténtelo mas tarde");
      }
    } else {
      var msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  });

  const updateConductor = form2.handleSubmit(async (data) => {
    const response = await petitions.updateConductor(idEmpresa(), session().token, data)
    if (response.status === "success") {
      if (response.data) {
        const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
        modalInstance.hide();
        setEstado(!estado);
        toast.success("Conductor actualizado correctamente"); 
      }
      else{
        const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
        modalInstance.hide();
        toast.warning("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
      const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
      modalInstance.hide();
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  });

  return (
    <>
      <div className="mb-9">
        <div className="row g-2 mb-4">
          <div className="col-auto">
            <h2 className="mb-0">Conductores</h2>
          </div>
        </div>
        <div className="mb-4">
          <div className="row g-10">
            <div className="col-auto">
              <div className="search-box">
                <input
                  className="form-control search-input search rounded-4 border-0 shadow-sm"
                  type="search"
                  placeholder="Buscar conductor"
                  aria-label="Search"
                  value={filtering}
                  onChange={(e) => setFiltering(e.target.value)}
                />
                <span className="fas fa-search search-box-icon"></span>
              </div>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-link text-body me-4 px-0"
                onClick={() =>
                  exportToExcel_v1(conductores, columns, "conductores")
                }
              >
                <span className="fa-solid fa-file-export fs-9 me-2"></span>
                Exportar
              </button>
              <button
                className="btn btn-primary rounded-4"
                data-bs-toggle="modal"
                data-bs-target="#modalAgregarConductor"
              >
                <span className="fas fa-plus me-2"></span>Nuevo conductor
              </button>
            </div>
          </div>
        </div>
        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
          <div className="table-responsive scrollbar-overlay mx-n1 px-1">
            {load ? (
              <TableLoad />
            ) : (
              <Table
                data={conductores}
                columns={columns}
                filtering={filtering}
                setFiltering={setFiltering}
              />
            )}
          </div>
        </div>
      </div>

      {/* MODALS */}
      <div
        className="modal fade"
        id="modalAgregarConductor"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Datos de conductor
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={sendConductor}>
              <div className="modal-body">
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Nombre
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("nombre", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                      maxLength: {
                        value: 32,
                        message: "El nombre es demasiado largo",
                      },
                    })}
                  />
                  {form1.formState.errors?.nombre && (
                    <code>{form1.formState.errors.nombre.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Apellido Paterno
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("paterno", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                      maxLength: {
                        value: 32,
                        message: "El apellido paterno es demasiado largo",
                      },
                    })}
                  />
                  {form1.formState.errors?.paterno && (
                    <code>{form1.formState.errors.paterno.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Apellido Materno
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("materno", {
                      maxLength: {
                        value: 32,
                        message: "El apeliido materno es demasiado largo",
                      },
                    })}
                  />
                  {form1.formState.errors?.materno && (
                    <code>{form1.formState.errors.materno.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Dirección
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("direccion", {
                      maxLength: {
                        value: 64,
                        message: "La dirección es demasiado larga",
                      },
                    })}
                  />
                  {form1.formState.errors?.direccion && (
                    <code>{form1.formState.errors.direccion.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Telefono
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("telefono", {
                      maxLength: {
                        value: 12,
                        message: "Telefono demasiado largo",
                      },
                    })}
                  />
                  {form1.formState.errors?.telefono && (
                    <code>{form1.formState.errors.telefono.message}</code>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Registrar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef2}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Editar conductor
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={updateConductor}>
              <div className="modal-body">
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Nombre
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form2.register("nombre", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                      maxLength: {
                        value: 32,
                        message: "El nombre es demasiado largo",
                      },
                    })}
                  />
                  {form2.formState.errors?.nombre && (
                    <code>{form2.formState.errors.nombre.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Apellido Paterno
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form2.register("paterno", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                      maxLength: {
                        value: 32,
                        message: "El apellido paterno es demasiado largo",
                      },
                    })}
                  />
                  {form2.formState.errors?.paterno && (
                    <code>{form2.formState.errors.paterno.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Apellido Materno
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form2.register("materno", {
                      maxLength: {
                        value: 32,
                        message: "El apeliido materno es demasiado largo",
                      },
                    })}
                  />
                  {form2.formState.errors?.materno && (
                    <code>{form2.formState.errors.materno.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Dirección
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form2.register("direccion", {
                      maxLength: {
                        value: 64,
                        message: "La dirección es demasiado larga",
                      },
                    })}
                  />
                  {form2.formState.errors?.direccion && (
                    <code>{form2.formState.errors.direccion.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Telefono
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form2.register("telefono", {
                      maxLength: {
                        value: 12,
                        message: "Telefono demasiado largo",
                      },
                    })}
                  />
                  {form2.formState.errors?.telefono && (
                    <code>{form2.formState.errors.telefono.message}</code>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Actualizar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

